import React from 'react';
import styled from 'styled-components';
import Image from 'next/image';
import Link from 'next/link';
import { utils } from '@makeship/core';

import posthog from 'posthog-js';
import { P2, S2Styles, S3Styles, Overline } from '../Typography';
import { parseGiftCardProductName } from '../../utils/product';
import { BadgeType } from '../../types/common';
import { isUserLoggedIn } from '../../utils/analytics';
import { useStore } from '../../store';

const CardWrapper = styled.div`
  display: block;
  text-align: center;
  margin-bottom: 72px;
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.tablet}px) {
    margin-bottom: 40px;
  }
`;

const CardLink = styled.a``;

const ImageWrapper = styled.div`
  cursor: pointer;
`;

const BadgeTitle = styled.p`
  ${S2Styles};
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.tablet}px) {
    ${S3Styles};
  }
`;

const UnlockedDate = styled(Overline)`
  color: ${({ theme }) => utils.hexToRGBA(theme.colors.neutral7, theme.alpha.dark)};
`;

type BadgeCardProps = {
  badge: Badge;
};

const BadgeCard: React.FC<BadgeCardProps> = ({ badge }: BadgeCardProps) => {
  const { state } = useStore();
  const renderBadgePosition = () =>
    badge.badgeType === BadgeType.Support ? (badge.position ? `# ${badge.position}` : '--') : 'Gifter';
  const renderProductTitle = () =>
    badge.badgeType === BadgeType.Support ? badge.product.title : parseGiftCardProductName(badge.product.title);

  return (
    <Link href={`/badges/${badge.badgeId}`} passHref>
      <CardLink
        onClick={() => {
          posthog.capture('badgeLibrary_badge_click', { badge, is_logged_in: isUserLoggedIn(state.user) });
        }}
      >
        <CardWrapper>
          <ImageWrapper>
            <Image
              src={badge.badgeFrontUrl}
              layout="responsive"
              width="500px"
              height="500px"
              alt="badge image"
              unoptimized
            />
          </ImageWrapper>
          <P2>{renderBadgePosition()}</P2>
          <BadgeTitle>{renderProductTitle()}</BadgeTitle>
          <UnlockedDate>Unlocked {utils.getDate(badge.createdOn)}</UnlockedDate>
        </CardWrapper>
      </CardLink>
    </Link>
  );
};

export default BadgeCard;
